var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-payment-box-wrapper"},[_vm._t("title"),_c('div',{staticClass:"checkout-payment-box-inner"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }